import { render } from "./SaveInlay.vue?vue&type=template&id=c89e625a"
import script from "./SaveInlay.vue?vue&type=script&lang=js"
export * from "./SaveInlay.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__